import { useEffect, useState } from 'react';

// True on narrow (phone-portrait) screens — the themed game stages switch
// from their landscape art aspect to a taller layout so the play elements
// stay finger-sized. 640px lines up with Tailwind's `sm` breakpoint.
// Ghost-tap shield: auto-advance mounts the next game right under the finger
// that answered the previous one, so a double-tap / iOS ghost click lands on
// the new game and "answers" it instantly. Call ok() in tap handlers — it
// returns false during the first `ms` after mount (and after re-arm()).
export function useTapShield(ms = 600) {
  const armedAt = useState(() => ({ t: Date.now() }))[0];
  return {
    ok: () => Date.now() - armedAt.t >= ms,
    rearm: () => { armedAt.t = Date.now(); },
  };
}

export function useCompact(breakpoint = 640) {
  const [compact, setCompact] = useState(
    typeof window !== 'undefined' && window.innerWidth < breakpoint,
  );
  useEffect(() => {
    const onResize = () => setCompact(window.innerWidth < breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);
  return compact;
}
